import { motion } from "framer-motion";

export const Header = () => (
    <motion.header
        data-testid="site-header"
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.9, delay: 0.15, ease: [0.16, 1, 0.3, 1] }}
        className="fixed inset-x-0 top-0 z-50 flex items-center justify-between border-b border-ink/5 bg-ivory/80 px-6 py-5 backdrop-blur-md md:px-12"
    >
        <a href="/" aria-label="RentOui home" data-testid="header-logo-link">
            <img
                src="/assets/logo-alt.png"
                alt="RentOui"
                className="h-7 w-auto md:h-8"
                data-testid="header-logo"
            />
        </a>
        <div className="flex items-center gap-8">
            <span
                className="label-xs hidden items-center gap-3 text-ink/60 md:flex"
                data-testid="status-label"
            >
                <span className="pulse-dot" aria-hidden="true" />
                Under maintenance
            </span>
            <a
                href="mailto:help@rentoui.com"
                className="link-underline label-xs text-ink"
                data-testid="header-email-link"
            >
                help@rentoui.com
            </a>
        </div>
    </motion.header>
);
